interface HeroBannerProps {
  challengeName: string;
  isWinner: boolean;
  payoutAmount: number;
  stakeAmount: number;
}

export function HeroBanner({
  challengeName,
  isWinner,
  payoutAmount,
  stakeAmount,
}: HeroBannerProps) {
  return (
    <div className="pt-8 px-4 flex flex-col items-center text-center relative overflow-hidden">
      {/* Background glow - more subtle for losers */}
      <div
        className={`absolute top-0 left-1/2 -translate-x-1/2 w-full h-64 blur-[80px] rounded-full pointer-events-none ${
          isWinner ? "bg-primary/5" : "bg-white/5"
        }`}
      />

      <div className="relative z-10 flex flex-col items-center">
        {/* Icon - Trophy for winners, Flag for losers */}
        <div
          className={`size-20 rounded-full bg-gradient-to-b flex items-center justify-center mb-4 ${
            isWinner
              ? "from-primary/20 to-primary/5 border border-primary/30 shadow-[0_0_30px_-5px_rgba(37,244,120,0.3)]"
              : "from-white/10 to-white/5 border border-white/10 shadow-[0_0_30px_-5px_rgba(255,255,255,0.1)]"
          }`}
        >
          <span
            className={`material-symbols-outlined text-5xl ${
              isWinner
                ? "text-primary drop-shadow-[0_0_10px_rgba(37,244,120,0.5)]"
                : "text-primary drop-shadow-[0_0_10px_rgba(13,242,13,0.3)]"
            }`}
            style={{
              fontVariationSettings:
                "'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 48",
            }}
          >
            {isWinner ? "emoji_events" : "flag"}
          </span>
        </div>

        {/* Title */}
        <h1 className="text-3xl font-extrabold uppercase tracking-tight text-white mb-1 ">
          Challenge
          <br />
          {isWinner ? "Conquered!" : "Fought!"}
        </h1>

        {/* Subtitle */}
        <p className="text-white/60 font-medium mb-6">
          {isWinner
            ? `You absolutely crushed the ${challengeName}.`
            : "You lost this challenge"}
        </p>

        {/* Payout/Stake Card */}
        <div className="flex flex-col items-center bg-white/5 rounded-4xl p-4 border border-white/10 w-full max-w-xs backdrop-blur-sm">
          <span className="text-[10px] font-semibold text-white/50 uppercase tracking-widest mb-1">
            {isWinner ? "Total Payout" : "Your Stake"}
          </span>
          <span
            className={`text-3xl font-extrabold tracking-tight ${
              isWinner ? "text-primary text-glow-sm" : "text-white"
            }`}
          >
            ${isWinner ? payoutAmount.toFixed(2) : stakeAmount.toFixed(2)}
          </span>
          {!isWinner && (
            <span className="text-[10px] font-bold text-primary uppercase tracking-wide bg-primary/10 px-2 py-0.5 rounded-full border border-primary/20 mt-2">
              Contributed to Pot
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
